const initSlider = () => {
  const sliderEls = document.querySelectorAll('[data-slider]');

  if (!sliderEls.length) {
    return;
  }

  sliderEls.forEach((slider) => {
    const thumbs = new window.Swiper(slider.querySelector('[data-thumbs]'), {
      loop: true,
      freeMode: true,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
    });

    const swiper = new window.Swiper(slider.querySelector('[data-slides]'), {
      loop: true,
      navigation: {
        prevEl: slider.querySelector('[data-prev-btn]'),
        nextEl: slider.querySelector('[data-next-btn]'),
      },
      thumbs: {
        swiper: thumbs,
      },
      effect: 'fade',
      speed: 1000,
    });
  });
};

export {initSlider};
